import moment from 'moment';
import { FETCH_ASSETS_URL } from 'appenv';

export const CUSTOM_USERS = [
  'SYSTEM',
  'system',
  'Announcement',
];

export const IE = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;

export const IMAGES = {
  GROUP_CHAT: `${FETCH_ASSETS_URL}/assets/groupChatIcon.svg`,
  ANNOUNCEMENT: `${FETCH_ASSETS_URL}/assets/announceIcon.svg`,
  FILE: `${FETCH_ASSETS_URL}/assets/filePreviewIcon.svg`,
} as const;

export const COLORS = {
  DARK_BLUE: '#2D3D49',
  WHITE: '#FFF',
  SKY_BLUE: '#5C8CF3',
  TEXT_DARK: '#484848',
  LIGHT_GREY: '#999',
  ERROR: '#F44336',
  GREY_S: '#F8F8F8', // Grey Small
  GREY_M: '#F0F1F2', // Grey Medium
  GREY_H: '#DBDEE2', // Grey High
  ICON: 'rgba(0, 0, 0, 0.54)',
} as const;

export const POSITIONING = {
  HEADER_HEIGHT: '48px',
  TITLE_HEIGHT: '68px',
  DESKTOP: {
    CHAT_BUTTON_WIDTH: '200px',
    PANEL_BUTTON_WIDTH: '760px',
    INTERFACE_HEIGHT: '550px',
    INTERFACE_WIDTH: '760px',
    LIST_WIDTH: '40%',
    CHAT_WIDTH: '60%',
  },
  FULLSCREEN: {
    INTERFACE_HEIGHT: '100vh',
    INTERFACE_WIDTH: '100vw',
  },
  BORDER_RADIUS: '12px',
} as const;

export const BEHAVIOR = {
  FETCH_MORE_MARGIN: 8,
  FETCH_PAGE_SIZE: 30,
  MAX_FETCH: 500,
  TIME_ZONE: moment.tz.guess(true),
  TIME_FORMAT: 'hh:mm',
  DATE_FORMAT: 'YYYY/MM/DD',
  JWT_MARGIN: 60 * 60, // 1 hour in seconds
  MOBILE_BREAKPOINT: 959,
  LARGE_DESKTOP_BREAKPOINT: 1200,
  MAX_TITLE_BUTTONS: 2,
  TITLE_BUTTON_WIDTH: 36,
  CHAT_GROUP_MAX_WIDTH: '75%',
  CHAT_ANIMATION_TIMEOUT: 500,
  CHAT_BACKDROP_TIMEOUT: 250,
  FILE_SIZE_LIMIT: 10 * 1000000,
  CHEVRON_SIZE: 184,
  CHAT_BADGE_MAX: 99,
} as const;

export const scrollBarStyles = `
  ::-webkit-scrollbar {
    width: 14px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 7px;
    border: 4px solid rgba(0, 0, 0, 0);
    background: ${COLORS.GREY_H};
    background-clip: padding-box;
    box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05),
      inset 1px 1px 0px rgba(0, 0, 0, 0.05);
  }
`;

export const RONGCLOUD_CONVTYPES = {
  0: 'NONE',
  1: 'PRIVATE',
  2: 'DISCUSSION',
  3: 'GROUP',
  4: 'CHATROOM',
  5: 'CUSTOMER_SERVICE',
  6: 'SYSTEM',
  7: 'APP_PUBLIC_SERVICE',
  8: 'PUBLIC_SERVICE',
  APP_PUBLIC_SERVICE: 7,
  CHATROOM: 4,
  CUSTOMER_SERVICE: 5,
  DISCUSSION: 2,
  GROUP: 3,
  NONE: 0,
  PRIVATE: 1,
  PUBLIC_SERVICE: 8,
  SYSTEM: 6,
};
